import { addAlert } from '../../../../MsgNotify/msgNotifyActions';
import { httpPost, httpGet, httpPut, httpDelete } from '../../../../Util/http';



export const GET_WORKPLACE_TASKS_REQUEST = 'GET_WORKPLACE_TASKS_REQUEST';
export const getWorkplaceTasksRequest = () => (
    {
        type: GET_WORKPLACE_TASKS_REQUEST
    }
)


export const GET_WORKPLACE_TASKS_SUCCESS = 'GET_WORKPLACE_TASKS_SUCCESS'
export const getWorkplaceTasksSuccess = (tasks) => (
    {
        type: GET_WORKPLACE_TASKS_SUCCESS,
        tasks: tasks ? tasks : []
    }
)

export const GET_WORKPLACE_TASKS_FAILURE = 'GET_WORKPLACE_TASKS_FAILURE'
export const getWorkplaceTasksFailure = () => (
    {
        type: GET_WORKPLACE_TASKS_FAILURE
    }
)

export const attemptGetWorkplaceTasks = (workplaceId) => {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/'+workplaceId+'/tasks';
    return (dispatch) => {
        dispatch(getWorkplaceTasksRequest())
        return httpGet(_url)
        .then(response => {
            return response.json();
        })
        .then(json => {
            dispatch(getWorkplaceTasksSuccess(json))
        })
        .catch(() => {
            dispatch(getWorkplaceTasksFailure())
            dispatch(addAlert("Kunne ikke hente opgaver"))
        })
    };
}




export const ADD_TASK_REQUEST = 'ADD_TASK_REQUEST';
export const addTaskRequest = (task) => (
    {
        type: ADD_TASK_REQUEST,
        task
    }
)

export const ADD_TASK_SUCCESS = 'ADD_TASK_SUCCESS'
export const addTaskSuccess = (taskId) => (
    {
        type: ADD_TASK_SUCCESS,
        taskId
    }
)

export const ADD_TASK_FAILURE = 'ADD_TASK_FAILURE'
export const addTaskFailure = () => (
    {
        type: ADD_TASK_FAILURE
    }
)

export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS'
export const deleteTaskSuccess = (index) => (
    {
        type: DELETE_TASK_SUCCESS,
        index
    }
)

export const attemptAddTask = (workplaceId, taskText) => {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/'+workplaceId+'/task';

    return (dispatch) => {
        dispatch(addTaskRequest({text: taskText, id: "dummyId", isChecked: false}))
        return httpPost(_url, {text: taskText})
        .then(response => {
            return response.json();
        })
        .then(id => {
            dispatch(addTaskSuccess(id))
        })
        .catch(() => {
            dispatch(addTaskFailure())
            dispatch(addAlert("Kunne ikke tilføje opgave"))
        })
  };
}

export const attemptDeleteTask = (workplaceId, taskId, index) => {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/task/' + taskId;

     return (dispatch) => {
        return httpDelete(_url)
        .then(() => {
            dispatch(deleteTaskSuccess(index))
        })
        .catch(() => {
            dispatch(addAlert("Kunne ikke slette opgaven"))
        })
   };
}



export const TOGGLE_TASK_IS_CHECKED_REQUEST = 'TOGGLE_TASK_IS_CHECKED_REQUEST';
export const toggleTaskIsCheckedRequest = (taskIndex, isChecked) => (
    {
        type: TOGGLE_TASK_IS_CHECKED_REQUEST,
        taskIndex,
        isChecked
    }
)

export const TOGGLE_TASK_IS_CHECKED_SUCCESS = 'TOGGLE_TASK_IS_CHECKED_SUCCESS'
export const toggleTaskIsCheckedSuccess = () => (
    {
        type: TOGGLE_TASK_IS_CHECKED_SUCCESS
    }
)

export const TOGGLE_TASK_IS_CHECKED_FAILURE = 'TOGGLE_TASK_IS_CHECKED_FAILURE'
export const toggleTaskIsCheckedFailure = (taskIndex, isChecked) => (
    {
        type: TOGGLE_TASK_IS_CHECKED_FAILURE,
        taskIndex,
        isChecked
    }
)

export const attemptToggleTaskIsChecked = (workplaceId, taskId, taskIndex, isChecked) => {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/task/' + taskId;

    return (dispatch) => {
        dispatch(toggleTaskIsCheckedRequest(taskIndex, isChecked))
        return httpPut(_url, {isChecked: isChecked})
        .then(() => {
            dispatch(toggleTaskIsCheckedSuccess())
        })
        .catch(() => {
            dispatch(toggleTaskIsCheckedFailure(taskIndex, !isChecked))
            dispatch(addAlert("Kunne ikke opdatere opgave"))
        })
  };
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Tasks/actions.js